let dd = require("ES/lib/dd");
let EvalForm = require("./EvalForm");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");

module.exports = dd.createClass({
  render: function(){
    let {event, Displaylists} = this.props;
    let is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);

    return dd.div({className: "Evals"},
        EvalForm({
          event,
          Displaylists,
          read_only: AuthedUserSession.privatelabel_code === "st" ? !AuthedUserSession.doIHaveAccess.full.any(event.sids) : false,
          is_limited_speaker: is_limited_speaker
        })
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/evals/index.js